









































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Table from '@/components/Table/Index.vue';
import ActivityBody from '@/components/Table/ActivityBody.vue';
import ActivityData from '@/data/ActivityData';
import { IfetchActivity, IActivityLog } from '@/interface/Activity';
import Breadcrumb from '@/components/Breadcrumb.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ActivityModule from '@/store/modules/Activity';
import Pagination from '@/components/Pagination.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';

@Component({
  components: {
    ActivityBody,
    Breadcrumb,
    Table,
    Pagination,
    DateRangeLogBody,
  },
})
export default class ActivityLogLogin extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  TableHeadActivity = ActivityData.TableHead;

  ActivityInstance = getModule(ActivityModule, this.$store);

  activityTypeList = [
    'ALL',
    'LOGIN',
    'REFRESH TOKEN',
  ];

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  userData: Array<IActivityLog> = [
    {
      ipAddress: '',
      timestamp: '',
      role: '',
      username: '',
      originalUrl: '',
    },
  ];

  search: IfetchActivity = {
    username: '',
  };

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  startDate = '';

  endDate = '';

  durationTime = '';

  logDetailModal = false;

  activityLogDetail = {
    username: '',
    role: '',
    timestamp: '',
    ipAddress: '',
    target: '',
    body: '',
    device: '',
    originalUrl: '',
  };

  created() {
    this.fetchActivityLog();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchActivityLog();
  }

  initial() {
    this.currentTool = 'Today';
    this.search.username = '';
  }

  changeDate(Tool) {
    this.durationTime = '';
    this.handleTool(Tool.key);
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchActivityLog();
  }

  async fetchActivityLog() {
    this.GeneralInstance.toggleLoading(true);
    const params = {
      ...this.Period,
      ...this.PaginationDetail,
      username: this.search.username,
    };
    const { data, status } = await this.ActivityInstance.FetchActivityLog(params);
    this.checkError(status);
    if (status.code === 0) {
      this.PaginationDetail.size = 100;
      this.PaginationDetail.amount = data.totalPage;
      this.PaginationDetail.current = data.page;
      this.userData = data.result;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  async fetchActivityLogDetail(id: string) {
    const { data, status } = await this.ActivityInstance.FetchActivityLogId({ id });
    if (status.code === 0) {
      this.logDetailModal = true;
      this.activityLogDetail = data;
    }
  }

  formatPrettyJson(value: unknown): string {
    if (value === null || value === undefined || value === '') return '-';

    // API sometimes returns JSON as a string. Try parse; if it fails, show raw.
    const parsed = (() => {
      if (typeof value !== 'string') return value;
      const trimmed = value.trim();
      if (!trimmed) return '-';
      if (!(trimmed.startsWith('{') || trimmed.startsWith('['))) return value;
      try {
        return JSON.parse(trimmed);
      } catch (e) {
        return value;
      }
    })();

    try {
      return typeof parsed === 'string' ? parsed : JSON.stringify(parsed, null, 2);
    } catch (e) {
      return String(value);
    }
  }

  onSubmit() {
    this.fetchActivityLog();
  }
}
